// Performance monitoring utilities
export const performanceMonitor = {
  // Mark performance checkpoints
  mark: (name: string) => {
    if ('performance' in window && performance.mark) {
      performance.mark(name);
    }
  },

  // Measure performance between two marks
  measure: (name: string, startMark: string, endMark?: string) => {
    if ('performance' in window && performance.measure) {
      try {
        performance.measure(name, startMark, endMark);
      } catch (error) {
        // Mark doesn't exist, ignore
      }
    }
  },

  // Get navigation timing for Core Web Vitals
  getNavigationTiming: () => {
    if ('performance' in window && performance.getEntriesByType) {
      const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      return {
        domContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
        loadComplete: navigation.loadEventEnd - navigation.loadEventStart,
        firstPaint: performance.getEntriesByName('first-paint')[0]?.startTime || 0,
        firstContentfulPaint: performance.getEntriesByName('first-contentful-paint')[0]?.startTime || 0,
      };
    }
    return null;
  },

  // Preload critical resources
  preloadResource: (href: string, as: string, crossorigin?: string) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = href;
    link.as = as;
    if (crossorigin) link.crossOrigin = crossorigin;
    document.head.appendChild(link);
  },

  // Prefetch likely navigation targets
  prefetchPage: (href: string) => {
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.appendChild(link);
  },
};

// Web Vitals tracking (simplified)
export const trackWebVitals = () => {
  // Only in production and with proper monitoring setup.
  // eslint-disable-next-line no-restricted-syntax -- PROD here means "compiled build", not deploy tier. Web Vitals tracking should fire on every Vercel deploy (so we capture dev / staging / prod paint times in observability) but NOT during `vite dev` where HMR makes measurements noisy.
  if (import.meta.env.PROD && 'performance' in window) {
    // Track Core Web Vitals here when monitoring service is available
    performanceMonitor.mark('app-start');
  }
};